import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import * as React from "react";

const AppUiDialogTitle = (props) => {
    const {children, onClose, ...other} = props;

    return (
        <DialogTitle sx={{m: 0, pt: 1, pb: 1, pl: 2, pr: 2, backgroundColor: '#363636', color: '#fefefe'}} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    size={"small"}
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon fontSize={"small"} sx={{color: '#fefefe'}}/>
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

AppUiDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default AppUiDialogTitle;